import { connect } from 'react-redux';

import Router from './Router.jsx';

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.token,
});

export default connect(mapStateToProps)(Router);
